/*
 * Baskas Rental Bundle v3.1 — date-first, 3-section layout
 * Loaded via <script defer>, namespace: window.BaskasRental
 */
window.BaskasRental = window.BaskasRental || {};

(function(BR) {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 1: CONFIG, STATE & UTILITIES
   * ═══════════════════════════════════════════════════════════════════ */

  BR.API_BASE = window.__baskasRentalApi || '';

  /* ── Hardcoded fallback defaults ───────────────────────────────── */
  var DEFAULTS = {
    pickup_rules: { days: [1,4], return_days: [1,4] },
    delivery_rules: { days_out: [5], days_back: [0], cost: 395, free_threshold: 1000 },
    locations: [
      { id: 'troejborg', name: 'Trøjborg', address: 'Edouard Suensons Gade 4, 8200 Aarhus N', hours: 'Man & tor kl. 16–21', active: true },
      { id: 'stjernepladsen', name: 'Stjernepladsen', address: 'Langelandsgade 205, 2.tv, 8200 Aarhus N', hours: 'Man & tor kl. 16–21', active: true }
    ],
    max_duration: 7,
    buffer_days: 0,
    addon_compat: [
      { key: 'ekstra-gen-4-batteri', models: ['GO','SB3','Mix','SB4'],  max_per: 2, reason: 'Vi tilbyder Gen 3 batteri til Soundboks 2 (billigere)' },
      { key: 'mikrofon',             models: ['SB3','SB4'],             max_per: 2, reason: 'Mikrofon kræver XLR-input (kun SB3 & SB4)' },
      { key: 'backpack',             models: ['SB2','SB3','SB4'],       max_per: 1, reason: 'Backpack passer ikke til GO & Mix' },
      { key: 'soundlock',            models: ['GO','SB2','SB3','Mix','SB4'], max_per: 1 },
      { key: 'lightboks',            models: ['GO','SB2','SB3','Mix','SB4'], max_per: 2 },
      { key: 'batteri',              models: ['SB2'],                    max_per: 2, reason: 'Vi tilbyder Gen 4 USB-C batteri til andre modeller' },
      { key: 'stand',                models: ['GO','SB2','SB3','Mix','SB4'], max_per: 1 }
    ],
    upsell_tiers: {
      1: null,
      2: { tag: 'MEST POPULÆR', perks: ['Stereo-lyd — dobbelt op på festen', 'Gratis ekstra AUX-adapter'], msg: '9 ud af 10 vender tilbage med stereo-setup' },
      3: { tag: 'FESTIVAL-MODE', perks: ['Alt fra 2 stk. pakken', 'Gratis levering (spar 395 kr.)', 'Prioriteret support — vi ringer dig op'], msg: 'Den ultimative fest-setup' }
    },
    model_labels: { GO: 'Soundboks GO', SB2: 'Soundboks 2', SB3: 'Soundboks 3', Mix: 'Soundboks Mix', SB4: 'Soundboks 4' },
    model_map: {
      'soundboks go': 'GO', 'soundboks 2': 'SB2', 'soundboks 3': 'SB3', 'soundboks 4': 'SB4', 'soundboks mix': 'Mix',
      'sb go': 'GO', 'sb2': 'SB2', 'sb3': 'SB3', 'sb4': 'SB4', 'mix': 'Mix', 'go': 'GO'
    },
    delivery_zones: []
  };

  /* ── Config cache ──────────────────────────────────────────────── */
  BR.config = {};
  var CONFIG_CACHE_KEY = 'baskasRentalConfig_v3';
  var CONFIG_CACHE_TTL = 5 * 60 * 1000;

  function parseConfigValues(data) {
    var result = {};
    for (var key in data) {
      if (typeof data[key] === 'string' && (data[key].charAt(0) === '{' || data[key].charAt(0) === '[')) {
        try { result[key] = JSON.parse(data[key]); } catch(e) { result[key] = data[key]; }
      } else {
        result[key] = data[key];
      }
    }
    return result;
  }

  BR.loadConfig = function() {
    try {
      var cached = localStorage.getItem(CONFIG_CACHE_KEY);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed._ts && Date.now() - parsed._ts < CONFIG_CACHE_TTL) {
          delete parsed._ts;
          BR.config = parseConfigValues(parsed);
          return Promise.resolve(BR.config);
        }
      }
    } catch(e) { /* ignore */ }

    if (!BR.API_BASE) {
      BR.config = DEFAULTS;
      return Promise.resolve(BR.config);
    }

    return fetch(BR.API_BASE + '/api/config')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        BR.config = parseConfigValues(data);
        try {
          var c = JSON.parse(JSON.stringify(BR.config));
          c._ts = Date.now();
          localStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify(c));
        } catch(e) {}
        return BR.config;
      })
      .catch(function() { BR.config = DEFAULTS; return BR.config; });
  };

  /* ── State ─────────────────────────────────────────────────────── */
  BR.state = {
    model: null, quantity: 1, availability: {},
    eventDate: null, eventEndDate: null, selectedWindow: null,
    fulfillment: 'pickup', contact: 'sms',
    calendarMonth: null, container: null,
    addons: [], selectedAddons: {}, variants: [],
    postalCode: '', postalCity: '', postalDeliverable: null,
    pickupLocation: null, deliveryAddress: '',
    eventType: '', comment: '', locationStock: {},
    _selecting: false
  };

  /* ── Danish locale ─────────────────────────────────────────────── */
  BR.DAY_NAMES = ['søn','man','tir','ons','tor','fre','lør'];
  BR.DAY_NAMES_SHORT = ['Sø','Ma','Ti','On','To','Fr','Lø'];
  BR.MONTH_NAMES = ['januar','februar','marts','april','maj','juni','juli','august','september','oktober','november','december'];
  BR.MONTH_NAMES_SHORT = ['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'];
  BR.CHK = '<svg class="bk2__icon-check" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>';
  BR.WARN = '<svg class="bk2__feedback-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  /* ── Utilities ─────────────────────────────────────────────────── */
  BR.util = {
    $: function(s, c) { return (c || document).querySelector(s); },
    $$: function(s, c) { return Array.from((c || document).querySelectorAll(s)); },
    fmtDate: function(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    },
    fmtMonth: function(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    },
    fmtShort: function(d) {
      var n = ['Søn','Man','Tir','Ons','Tor','Fre','Lør'];
      return n[d.getDay()] + ' ' + d.getDate() + '. ' + BR.MONTH_NAMES_SHORT[d.getMonth()];
    },
    daysBetween: function(a, b) { return Math.round((b - a) / 86400000); },
    sameDay: function(a, b) { return a && b && BR.util.fmtDate(a) === BR.util.fmtDate(b); },
    dateFromStr: function(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); },
    addDays: function(d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; },
    esc: function(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; },
    fmtPrice: function(n) {
      var parts = (Math.round(n * 100) / 100).toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' kr';
    },
    fmtPriceShort: function(n) { return Math.round(n) + ' kr.'; },
    scrollToEl: function(el) {
      if (!el) return;
      setTimeout(function() {
        var r = el.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.7 || r.top < -50) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 350);
    }
  };

  /* ── Detect model from Shopify variant picker ─────────────────── */
  BR.detectModel = function() {
    var $ = BR.util.$;
    var map = BR.config.model_map || DEFAULTS.model_map;
    var checked = $('input[name="Model"]:checked');
    if (checked) {
      var item = checked.closest('.product-form__swatch__item');
      if (item) {
        var v = (item.dataset.value || '').toLowerCase();
        for (var k in map) { if (v.indexOf(k) !== -1) return map[k]; }
      }
    }
    var sel = $('.product-form__selected-value, [data-option-value][aria-checked="true"]');
    if (sel) {
      var t = sel.textContent.trim().toLowerCase();
      for (var k2 in map) { if (t.indexOf(k2) !== -1) return map[k2]; }
    }
    var title = ($('.product-title, h1.product__title, [data-product-title]') || {}).textContent || '';
    title = title.toLowerCase();
    for (var k3 in map) { if (title.indexOf(k3) !== -1) return map[k3]; }
    return window.__baskasVariantModel || 'SB4';
  };

  BR.detectQuantity = function() {
    var $ = BR.util.$;
    var checked = $('input[name="Antal"]:checked');
    if (checked) {
      var item = checked.closest('.product-form__swatch__item');
      if (item) { var m = (item.dataset.value || '').match(/^(\d)/); if (m) return parseInt(m[1]); }
    }
    var qi = $('input[name="quantity"]');
    return qi ? (parseInt(qi.value) || 1) : 1;
  };

  BR.parseVariants = function() {
    var s = BR.util.$('variant-radios script[type="application/json"]');
    if (!s) return;
    try { BR.state.variants = JSON.parse(s.textContent); } catch(e) { BR.state.variants = []; }
  };

  BR.getVariantPrice = function() {
    var labels = BR.config.model_labels || DEFAULTS.model_labels;
    var ml = (labels[BR.state.model] || BR.state.model || '').toLowerCase();
    var qStr = String(BR.state.quantity);
    for (var i = 0; i < BR.state.variants.length; i++) {
      var v = BR.state.variants[i];
      if ((v.option1 || '').toLowerCase().indexOf(ml) !== -1 && (v.option2 || '').charAt(0) === qStr) {
        return v.price / 100;
      }
    }
    var pe = BR.util.$('.price__number .money, .product-price__amount, [data-product-price]');
    if (pe) {
      var t = pe.textContent.replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.');
      return parseFloat(t) || 0;
    }
    return 0;
  };

  /* ── Config accessors with fallback ────────────────────────────── */
  function getPickupRules()  { return BR.config.pickup_rules || DEFAULTS.pickup_rules; }
  function getDeliveryRules() { return BR.config.delivery_rules || DEFAULTS.delivery_rules; }
  function getMaxDuration()  { return BR.config.max_duration || DEFAULTS.max_duration; }
  function getLabels()       { return BR.config.model_labels || DEFAULTS.model_labels; }
  function getLocations()    { return (BR.config.locations || DEFAULTS.locations).filter(function(l) { return l.active !== false; }); }
  function getUpsell()       { return BR.config.upsell_tiers || DEFAULTS.upsell_tiers; }


  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 2: CALENDAR
   * ═══════════════════════════════════════════════════════════════════ */

  var cal = BR.calendar = {};
  var S = BR.state;
  var U = BR.util;

  /* ── Availability API ──────────────────────────────────────────── */

  /*
   * Generation counter: incremented on every model/qty change.
   * Stale fetch callbacks check this and bail out if it changed.
   * This is the single fix for all race conditions from rapid clicking.
   */
  var _gen = 0;

  cal.fetchAvailability = function(model, monthStr, cb) {
    var ck = model + ':' + monthStr + ':' + S.quantity;
    if (S.availability[ck]) { cb(S.availability[ck]); return; }
    if (!BR.API_BASE) { cb([]); return; }
    var myGen = _gen; /* Capture current generation */
    fetch(BR.API_BASE + '/api/availability/' + model + '?month=' + monthStr + '&quantity=' + S.quantity)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(d) {
        if (_gen !== myGen) return;
        if (d.days && d.days.length > 0) {
          S.availability[ck] = d.days;
          cb(d.days);
        } else {
          /* No days = API error or empty response — retry once after 2s */
          setTimeout(function() {
            if (_gen !== myGen) return;
            fetch(BR.API_BASE + '/api/availability/' + model + '?month=' + monthStr + '&quantity=' + S.quantity)
              .then(function(r2) { return r2.ok ? r2.json() : { days: [] }; })
              .then(function(d2) {
                if (_gen !== myGen) return;
                S.availability[ck] = d2.days || [];
                cb(d2.days || []);
              })
              .catch(function() { cb([]); });
          }, 2000);
        }
      })
      .catch(function() {
        if (_gen !== myGen) return;
        /* Retry once after 2s on network error */
        setTimeout(function() {
          if (_gen !== myGen) return;
          fetch(BR.API_BASE + '/api/availability/' + model + '?month=' + monthStr + '&quantity=' + S.quantity)
            .then(function(r2) { return r2.ok ? r2.json() : { days: [] }; })
            .then(function(d2) {
              if (_gen !== myGen) return;
              S.availability[ck] = d2.days || [];
              cb(d2.days || []);
            })
            .catch(function() { cb([]); });
        }, 2000);
      });
  };

  cal.hasDataForMonth = function(monthStr) {
    var ck = S.model + ':' + monthStr + ':' + S.quantity;
    return !!S.availability[ck];
  };

  cal.isDateAvailable = function(ds) {
    var found = false;
    for (var k in S.availability) {
      if (k.indexOf(S.model + ':') !== 0) continue;
      var d = S.availability[k];
      for (var i = 0; i < d.length; i++) {
        if (d[i].date === ds) return !d[i].blocked && d[i].available > 0;
      }
      found = true;
    }
    return found; /* No data for this date = assume available */
  };

  cal.getAvailInfo = function(ds) {
    for (var k in S.availability) {
      if (k.indexOf(S.model + ':') !== 0) continue;
      var d = S.availability[k];
      for (var i = 0; i < d.length; i++) { if (d[i].date === ds) return d[i]; }
    }
    return null;
  };

  /* ── Location stock API ────────────────────────────────────────── */
  cal.fetchLocationStock = function(date, model, quantity, cb) {
    if (!BR.API_BASE) { cb({}); return; }
    var ds = typeof date === 'string' ? date : U.fmtDate(date);
    var ck = ds + ':' + model + ':' + quantity;
    if (S.locationStock[ck]) { cb(S.locationStock[ck]); return; }
    fetch(BR.API_BASE + '/api/availability/locations?date=' + ds + '&model=' + model + '&quantity=' + quantity)
      .then(function(r) { return r.json(); })
      .then(function(data) { S.locationStock[ck] = data; cb(data); })
      .catch(function() { cb({}); });
  };

  /* ── Window calculator ─────────────────────────────────────────── */
  cal.calculateWindows = function(eventDate, mode) {
    var maxDur = getMaxDuration();
    var pickupDays, returnDays;
    if (mode === 'delivery') {
      var dr = getDeliveryRules();
      pickupDays = dr.days_out || [5];
      returnDays = dr.days_back || [0];
    } else {
      var pr = getPickupRules();
      pickupDays = pr.days || [1,4];
      returnDays = pr.return_days || [1,4];
    }

    var windows = [], today = new Date();
    today.setHours(0, 0, 0, 0);
    var pickups = [], returns = [];

    for (var d = 0; d <= maxDur; d++) {
      var day1 = U.addDays(eventDate, -d);
      if (day1 >= today && pickupDays.indexOf(day1.getDay()) !== -1) pickups.push(day1);
      var day2 = U.addDays(eventDate, d);
      if (returnDays.indexOf(day2.getDay()) !== -1) returns.push(day2);
    }

    for (var p = 0; p < pickups.length; p++) {
      for (var r = 0; r < returns.length; r++) {
        var dur = U.daysBetween(pickups[p], returns[r]);
        if (dur < 1 || dur > maxDur || pickups[p] > eventDate || returns[r] < eventDate) continue;
        var ok = true;
        for (var c = 0; c <= dur; c++) {
          if (!cal.isDateAvailable(U.fmtDate(U.addDays(pickups[p], c)))) { ok = false; break; }
        }
        if (ok) windows.push({ start: pickups[p], end: returns[r], days: dur });
      }
    }
    windows.sort(function(a, b) { return a.days - b.days; });
    return windows;
  };

  cal.diagnoseNoWindows = function(eventDate, mode) {
    var maxDur = getMaxDuration();
    var pickupDays = mode === 'delivery' ? (getDeliveryRules().days_out || [5]) : (getPickupRules().days || [1,4]);
    var today = new Date(); today.setHours(0, 0, 0, 0);

    var ei = cal.getAvailInfo(U.fmtDate(eventDate));
    if (ei && ei.blocked) return 'blocked';
    if (ei && ei.available <= 0) return 'soldout';

    var blocked = 0, total = 0;
    for (var d = -maxDur; d <= maxDur; d++) {
      var cd = U.addDays(eventDate, d);
      if (cd < today) continue;
      var info = cal.getAvailInfo(U.fmtDate(cd));
      if (info) { total++; if (info.blocked || info.available <= 0) blocked++; }
    }
    if (total > 0 && blocked / total > 0.6) return 'festival';

    for (var d2 = 0; d2 <= maxDur; d2++) {
      var pd = U.addDays(eventDate, -d2);
      if (pd >= today && pickupDays.indexOf(pd.getDay()) !== -1) return 'nowindow';
    }
    return 'toosoon';
  };

  /* ── Render single month grid ──────────────────────────────────── */
  /*
   * DESIGN: The event date calendar is ALWAYS fully clickable.
   * Only past dates are disabled. We never block based on availability here.
   * Availability is checked AFTER the user picks a date, when calculating
   * rental windows. This prevents the greying-out problem entirely.
   * Green dots / "Udsolgt" are shown as hints only — not as blockers.
   */
  cal.renderMonth = function(month) {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var first = new Date(month.getFullYear(), month.getMonth(), 1);
    var last = new Date(month.getFullYear(), month.getMonth() + 1, 0);
    var startDow = (first.getDay() + 6) % 7;

    var html = '<div class="bk2__cal-grid">';

    for (var h = 0; h < 7; h++) html += '<div class="bk2__cal-hdr">' + BR.DAY_NAMES_SHORT[(h + 1) % 7] + '</div>';
    for (var e = 0; e < startDow; e++) html += '<div class="bk2__cal-day bk2__cal-day--empty"></div>';

    for (var d = 1; d <= last.getDate(); d++) {
      var date = new Date(month.getFullYear(), month.getMonth(), d);
      var ds = U.fmtDate(date);
      var isPast = date < today;
      var info = cal.getAvailInfo(ds);

      /* Only past dates are truly disabled — everything else is clickable */
      var isEvt = U.sameDay(date, S.eventDate);
      var isEnd = S.eventEndDate && U.sameDay(date, S.eventEndDate);
      var inEvtRange = S.eventDate && S.eventEndDate && date > S.eventDate && date < S.eventEndDate;
      var inWin = false, isWEnd = false;

      if (S.selectedWindow) {
        inWin = date >= S.selectedWindow.start && date <= S.selectedWindow.end && !isEvt && !isEnd;
        if (!isEvt && !isEnd) {
          isWEnd = U.sameDay(date, S.selectedWindow.start) || U.sameDay(date, S.selectedWindow.end);
        }
      }

      var cls = 'bk2__cal-day';
      if (isPast) cls += ' bk2__cal-day--disabled';
      if (U.sameDay(date, today) && !isEvt) cls += ' bk2__cal-day--today';
      if (isEvt) cls += ' bk2__cal-day--event';
      if (isEnd) cls += ' bk2__cal-day--event bk2__cal-day--event-end';
      if (inEvtRange) cls += ' bk2__cal-day--in-event-range';
      if (inWin) cls += ' bk2__cal-day--in-range';
      if (isWEnd) cls += ' bk2__cal-day--window-end';

      /* Availability dot — simple green/none, no stock numbers */
      var dot = '';
      if (!isPast && info && !info.blocked && info.available > 0) {
        dot = '<span class="bk2__cal-avail"></span>';
      }

      var tooltip = '';
      if (!isPast && info && (info.blocked || info.available <= 0)) {
        tooltip = ' title="' + (info.reason ? U.esc(info.reason) : 'Ikke tilg\u00e6ngelig') + '"';
      }

      html += '<div class="' + cls + '" data-date="' + ds + '"' + tooltip + '>' +
        '<span class="bk2__cal-num">' + d + '</span>' + dot + '</div>';
    }
    return html + '</div>';
  };

  /* ── Render single-month calendar with nav ─────────────────────── */
  cal.render = function() {
    var wrap = U.$('#bk2-calendar', S.calWrap) || U.$('#bk2-calendar');
    if (!wrap) return;

    var month = S.calendarMonth;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var canPrev = new Date(month.getFullYear(), month.getMonth(), 1) > new Date(today.getFullYear(), today.getMonth(), 1);
    var canNext = new Date(month.getFullYear(), month.getMonth() + 1, 1) <= new Date(2027, 0, 1); /* Through January 2027 */
    var monthLabel = BR.MONTH_NAMES[month.getMonth()].charAt(0).toUpperCase() + BR.MONTH_NAMES[month.getMonth()].slice(1) + ' ' + month.getFullYear();

    var html = '<div class="bk2__cal-header">' +
      '<button class="bk2__cal-nav' + (canPrev ? '' : ' bk2__cal-nav--disabled') + '" data-dir="-1" type="button">' +
        '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<span class="bk2__cal-month">' + monthLabel + '</span>' +
      '<button class="bk2__cal-nav' + (canNext ? '' : ' bk2__cal-nav--disabled') + '" data-dir="1" type="button">' +
        '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M9 18l6-6-6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
    '</div>';

    html += cal.renderMonth(month);

    html += '<div class="bk2__cal-legend">' +
      '<span class="bk2__cal-legend-item"><span class="bk2__cal-avail"></span> Ledig</span>' +
    '</div>';

    if (S.eventDate) {
      html += '<div class="bk2__cal-instruction">Godt valg! Fortsæt nedenfor med at vælge model og tilbehør</div>';
    }

    wrap.innerHTML = html;

    /* Nav handlers */
    U.$$('.bk2__cal-nav:not(.bk2__cal-nav--disabled)', wrap).forEach(function(btn) {
      btn.addEventListener('click', function(ev) {
        ev.preventDefault();
        var dir = parseInt(btn.dataset.dir);
        S.calendarMonth = new Date(month.getFullYear(), month.getMonth() + dir, 1);
        cal.fetchAvailability(S.model, U.fmtMonth(S.calendarMonth), function() { cal.render(); });
      });
    });

    /* Date click handlers */
    U.$$('.bk2__cal-day:not(.bk2__cal-day--empty)', wrap).forEach(function(cell) {
      cell.addEventListener('click', function() {
        if (cell.classList.contains('bk2__cal-day--disabled')) {
          var info = cal.getAvailInfo(cell.dataset.date);
          U.$$('.bk2__cal-tooltip').forEach(function(t) { t.remove(); });
          if (info && info.blocked) {
            var tip = document.createElement('div');
            tip.className = 'bk2__cal-tooltip';
            if (info.reason && info.event_slug) {
              /* Festival-blocked: show name + link to the right product */
              tip.innerHTML = '<strong>' + U.esc(info.reason) + '</strong><br>'
                + '<a href="/products/' + info.event_slug + '-soundboks" style="color:#fa4619;text-decoration:none;font-weight:600">'
                + 'Vil du leje til ' + U.esc(info.reason.replace(/ 2026$/, '')) + '? Se her &rarr;</a>';
            } else if (info.reason) {
              tip.textContent = info.reason;
            } else {
              tip.textContent = 'Denne dato er ikke tilgængelig';
            }
            cell.appendChild(tip);
            setTimeout(function() { tip.remove(); }, 5000);
          }
          return;
        }
        cal.onDateClicked(U.dateFromStr(cell.dataset.date));
      });
    });
  };

  /* ── Date click (single day only) ──────────────────────────────── */
  cal.onDateClicked = function(date) {
    if (S._selecting) return;
    S._selecting = true;
    setTimeout(function() { S._selecting = false; }, 200);

    /* Clear any previous error/feedback messages */
    U.$$('.bk2__feedback, .bk2__cal-tooltip').forEach(function(el) { el.remove(); });
    var fb = U.$('#bk2-feedback', S.container);
    if (fb) fb.innerHTML = '';

    S.eventDate = date;
    S.eventEndDate = null;
    S.selectedWindow = null;
    S.selectedAddons = {};
    /* Navigate calendar to the month of the selected date */
    var selMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    if (selMonth.getTime() !== S.calendarMonth.getTime()) {
      S.calendarMonth = selMonth;
    }
    cal.render();
    BR.ui.onDateSelected();
    BR.ui.syncStepStates();
  };


  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 3: MODEL SELECTION
   * ═══════════════════════════════════════════════════════════════════ */

  var models = BR.models = {};

  models.getAvailableForDate = function(date) {
    var ds = U.fmtDate(date);
    var allModels = Object.keys(DEFAULTS.model_labels);
    var result = [];
    for (var mi = 0; mi < allModels.length; mi++) {
      var model = allModels[mi], avail = null;
      for (var k in S.availability) {
        if (!k.startsWith(model + ':')) continue;
        var d = S.availability[k];
        for (var i = 0; i < d.length; i++) {
          if (d[i].date === ds) { avail = d[i]; break; }
        }
        if (avail) break;
      }
      result.push({
        model: model,
        available: avail ? (!avail.blocked && avail.available > 0) : true,
        stock: avail ? avail.available : null
      });
    }
    return result;
  };

  models.render = function() {
    var wrap = U.$('#bk2-model-list', S.container);
    if (!wrap || !S.eventDate) return;

    var labels = getLabels();
    var available = models.getAvailableForDate(S.eventDate);
    var html = '';

    for (var i = 0; i < available.length; i++) {
      var m = available[i];
      var label = labels[m.model] || m.model;
      var isActive = m.model === S.model;
      var disabled = !m.available;

      html += '<div class="bk2__model-card' + (isActive ? ' bk2__model-card--active' : '') +
        (disabled ? ' bk2__model-card--disabled' : '') + '" data-model="' + m.model + '">';
      html += '<div class="bk2__model-name">' + U.esc(label) + '</div>';
      if (disabled) {
        html += '<span class="bk2__model-badge bk2__model-badge--sold">Udsolgt</span>';
      }
      html += '</div>';
    }
    wrap.innerHTML = html;

    U.$$('.bk2__model-card:not(.bk2__model-card--disabled)', wrap).forEach(function(card) {
      card.addEventListener('click', function() {
        S.model = card.dataset.model;
        U.$$('.bk2__model-card', wrap).forEach(function(c) {
          c.classList.toggle('bk2__model-card--active', c === card);
        });
        BR.ui.onModelSelected();
        BR.ui.syncStepStates();
      });
    });
  };


  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 4: ADD-ONS
   * ═══════════════════════════════════════════════════════════════════ */

  var addons = BR.addons = {};
  var ADDONS_COLLECTION = '/collections/accessorys/products.json';
  var FALLBACK_ADDON_RULES = DEFAULTS.addon_compat;
  var _addonAvail = {};

  /* Use FALLBACK until backend runs migration 006 */
  function getAddonRules() { return FALLBACK_ADDON_RULES; }

  addons.fetchAddons = function() {
    return fetch(ADDONS_COLLECTION)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        S.addons = (d.products || []).map(function(p) {
          var v = p.variants[0];
          for (var vi = 0; vi < p.variants.length; vi++) {
            if (p.variants[vi].title === 'Fest') { v = p.variants[vi]; break; }
          }
          return {
            id: p.id, title: p.title, handle: p.handle,
            price: parseFloat(v.price), variantId: v.id,
            image: (p.images && p.images[0]) ? p.images[0].src.replace(/\.([a-z]+)\?/, '_100x.$1?') : '',
            available: v.available !== false
          };
        });
        /* Re-render addons if a date is already selected (handles variant URL page loads) */
        if (S.eventDate) addons.render();
      })
      .catch(function() { S.addons = []; });
  };

  addons.fetchAvailability = function(start, end) {
    if (!BR.API_BASE) return Promise.resolve({});
    var key = start + ':' + end;
    if (_addonAvail[key]) return Promise.resolve(_addonAvail[key]);
    return fetch(BR.API_BASE + '/api/addons/availability?start=' + start + '&end=' + end)
      .then(function(r) { return r.json(); })
      .then(function(data) { _addonAvail[key] = data; return data; })
      .catch(function() { return {}; });
  };

  addons.getRule = function(handle) {
    var rules = getAddonRules();
    for (var i = 0; i < rules.length; i++) {
      if (handle.indexOf(rules[i].key) !== -1) return rules[i];
    }
    return { key: '_', models: ['GO','SB2','SB3','Mix','SB4'], max_per: 2 };
  };

  addons.isCompat = function(handle, model) {
    return addons.getRule(handle).models.indexOf(model) !== -1;
  };

  addons.getMax = function(handle) {
    return addons.getRule(handle).max_per * S.quantity;
  };

  addons.clampQuantities = function() {
    var changed = false;
    for (var vid in S.selectedAddons) {
      var addon = null;
      for (var i = 0; i < S.addons.length; i++) {
        if (String(S.addons[i].variantId) === String(vid)) { addon = S.addons[i]; break; }
      }
      if (!addon || !addons.isCompat(addon.handle, S.model)) {
        delete S.selectedAddons[vid]; changed = true; continue;
      }
      var max = addons.getMax(addon.handle);
      if (S.selectedAddons[vid] > max) {
        if (max <= 0) delete S.selectedAddons[vid]; else S.selectedAddons[vid] = max;
        changed = true;
      }
    }
    return changed;
  };

  function getAddonStock(handle) {
    if (!S.selectedWindow) return null;
    var key = U.fmtDate(S.selectedWindow.start) + ':' + U.fmtDate(S.selectedWindow.end);
    var avail = _addonAvail[key];
    if (!avail) return null;
    return avail[handle] !== undefined ? avail[handle] : null;
  }

  addons.render = function() {
    var wrap = U.$('#bk2-addons-list', S.container);
    if (!wrap || S.addons.length === 0) return;
    if (S.selectedWindow && BR.API_BASE) {
      addons.fetchAvailability(U.fmtDate(S.selectedWindow.start), U.fmtDate(S.selectedWindow.end))
        .then(function() { renderAddonCards(wrap); });
    }
    renderAddonCards(wrap);
  };

  function renderAddonCards(wrap) {
    var labels = getLabels();
    var html = '';

    for (var i = 0; i < S.addons.length; i++) {
      var a = S.addons[i];
      if (!a.available) continue;
      var compat = addons.isCompat(a.handle, S.model);
      var rule = addons.getRule(a.handle);
      var maxQty = addons.getMax(a.handle);
      var curQty = S.selectedAddons[a.variantId] || 0;
      var stock = getAddonStock(a.handle);
      var oos = stock !== null && stock <= 0;

      if (!compat || oos) {
        var reason = oos ? 'Udsolgt' : (rule.reason || 'Ikke kompatibel med ' + (labels[S.model] || S.model));
        html += '<div class="bk2__addon-card bk2__addon-card--disabled">' +
          '<div class="bk2__addon-check"><span class="bk2__addon-checkbox bk2__addon-checkbox--disabled"></span></div>' +
          (a.image ? '<img class="bk2__addon-img" src="' + a.image + '" alt="" loading="lazy">' : '') +
          '<div class="bk2__addon-info"><span class="bk2__addon-title">' + U.esc(a.title) + '</span>' +
          '<span class="bk2__addon-compat">' + reason + '</span></div></div>';
        continue;
      }

      var active = curQty > 0;
      html += '<div class="bk2__addon-card' + (active ? ' bk2__addon-card--active' : '') + '" data-variant="' + a.variantId + '" data-handle="' + a.handle + '">' +
        '<div class="bk2__addon-check"><span class="bk2__addon-checkbox' + (active ? '' : ' bk2__addon-checkbox--empty') + '"></span></div>' +
        (a.image ? '<img class="bk2__addon-img" src="' + a.image + '" alt="" loading="lazy">' : '') +
        '<div class="bk2__addon-info"><span class="bk2__addon-title">' + U.esc(a.title) + '</span>' +
        '<span class="bk2__addon-price">+ ' + Math.round(a.price) + ' kr.' +
        (maxQty > 1 ? ' <span class="bk2__addon-max">(max ' + maxQty + ')</span>' : '') + '</span></div>' +
        '<div class="bk2__addon-qty">' +
          '<button class="bk2__addon-qty-btn" data-dir="-1" type="button">\u2212</button>' +
          '<span class="bk2__addon-qty-val">' + curQty + '</span>' +
          '<button class="bk2__addon-qty-btn" data-dir="1" type="button">+</button>' +
        '</div></div>';
    }
    wrap.innerHTML = html;

    /* Bind events */
    U.$$('.bk2__addon-card[data-variant]', wrap).forEach(function(card) {
      function updateAddon(dir) {
        var vid = card.dataset.variant;
        var max = addons.getMax(card.dataset.handle);
        var cur = S.selectedAddons[vid] || 0;
        var nq = Math.max(0, Math.min(max, cur + dir));
        if (nq === 0) delete S.selectedAddons[vid]; else S.selectedAddons[vid] = nq;
        addons.render();
        BR.ui.renderSummary();
        BR.ui.updateDeliveryProgress();
        BR.ui.updateStickyBar();
        BR.cart.setLineItemProps();
      }
      U.$$('.bk2__addon-qty-btn', card).forEach(function(btn) {
        btn.addEventListener('click', function(ev) { ev.stopPropagation(); updateAddon(parseInt(btn.dataset.dir)); });
      });
      card.addEventListener('click', function(ev) {
        if (ev.target.closest('.bk2__addon-qty-btn')) return;
        var vid = card.dataset.variant;
        if (S.selectedAddons[vid]) delete S.selectedAddons[vid]; else S.selectedAddons[vid] = 1;
        addons.render();
        BR.ui.renderSummary();
        BR.ui.updateDeliveryProgress();
        BR.ui.updateStickyBar();
        BR.cart.setLineItemProps();
      });
    });
  }

  addons.getTotal = function() {
    var total = 0;
    for (var vid in S.selectedAddons) {
      for (var i = 0; i < S.addons.length; i++) {
        if (String(S.addons[i].variantId) === String(vid)) {
          total += S.addons[i].price * S.selectedAddons[vid];
        }
      }
    }
    return total;
  };


  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 5: CART / CHECKOUT
   * ═══════════════════════════════════════════════════════════════════ */

  var cart = BR.cart = {};

  cart.getDeliveryCost = function() {
    if (S.fulfillment !== 'delivery') return 0;
    var r = getDeliveryRules();
    var total = BR.getVariantPrice() + addons.getTotal();
    return total >= (r.free_threshold || 1000) ? 0 : (r.cost || 395);
  };

  cart.getTotal = function() {
    return BR.getVariantPrice() + addons.getTotal() + cart.getDeliveryCost();
  };

  cart.setLineItemProps = function() {
    if (!S.selectedWindow) return;

    var props = {
      'rental_start': U.fmtDate(S.selectedWindow.start),
      'rental_end': U.fmtDate(S.selectedWindow.end),
      'levering': S.fulfillment === 'delivery' ? 'Levering' : 'Afhentning',
      'kontakt': S.contact === 'sms' ? 'SMS' : 'Opkald',
      '_rental_model': S.model,
      '_event_date': U.fmtDate(S.eventDate),
      '_rental_date': U.fmtDate(S.eventDate),
      '_rental_fulfillment': S.fulfillment === 'delivery' ? 'Levering' : 'Afhentning',
      '_rental_contact': S.contact === 'sms' ? 'SMS' : 'Opkald'
    };

    if (S.postalCode) props['_postal_code'] = S.postalCode;
    if (S.fulfillment === 'pickup' && S.pickupLocation) props['_pickup_location'] = S.pickupLocation;
    if (S.fulfillment === 'delivery' && S.deliveryAddress) props['_delivery_address'] = S.deliveryAddress;

    var et = U.$('#bk2-event-type'), cm = U.$('#bk2-comment');
    if (et && et.value.trim()) { props['begivenhed'] = et.value.trim(); props['_rental_event_type'] = et.value.trim(); }
    if (cm && cm.value.trim()) { props['kommentar'] = cm.value.trim(); props['_rental_comment'] = cm.value.trim(); }

    var aIds = Object.keys(S.selectedAddons);
    if (aIds.length > 0) {
      props['_addons'] = aIds.map(function(v) { return v + ':' + S.selectedAddons[v]; }).join(',');
    }

    var form = U.$('form[action*="/cart/add"]');
    if (!form) return;
    U.$$('input[data-bk-prop]', form).forEach(function(el) { el.remove(); });
    for (var key in props) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + key + ']';
      inp.value = props[key];
      inp.setAttribute('data-bk-prop', 'true');
      form.appendChild(inp);
    }
    cart.setupAddonCart();
  };

  cart.removeLineItemProps = function() {
    var form = U.$('form[action*="/cart/add"]');
    if (form) U.$$('input[data-bk-prop]', form).forEach(function(el) { el.remove(); });
  };

  cart.setupAddonCart = function() {
    if (S._addonObserver) return;
    S._addonObserver = true;
    var last = 0;
    var form = U.$('form[action*="/cart/add"]');
    if (!form) return;

    if (form._bkHandler) form.removeEventListener('submit', form._bkHandler);
    form._bkHandler = function() {
      var items = [];
      for (var vid in S.selectedAddons) items.push({ id: parseInt(vid), quantity: S.selectedAddons[vid] });
      if (!items.length) return;
      last = Date.now();
      setTimeout(function() {
        if (Date.now() - last < 3000) {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function() {
            return fetch(root + 'cart.js');
          }).then(function(r) { return r.json(); }).then(function(cd) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cd } }));
            U.$$('[data-cart-count],.cart-link__count,.js-cart-count').forEach(function(el) { el.textContent = cd.item_count; });
          }).catch(function() {});
        }
      }, 800);
    };
    form.addEventListener('submit', form._bkHandler, true);
  };

  cart.onCheckoutClick = function() {
    /* Mobile race: a user may tap Book within the 30ms syncStepStates
     * debounce window (e.g., autocomplete fills the postal field then they
     * immediately tap). Force the sync to run now so the guard below sees
     * the freshest state instead of rejecting a complete booking. */
    if (ui && ui._doSyncStepStates) {
      try { ui._doSyncStepStates(); } catch (e) { /* ignore */ }
    }

    if (!S.eventDate || !S.model || !S.selectedWindow) {
      alert('Vælg venligst dato, model og lejeperiode inden du booker.');
      return;
    }

    var btn = U.$('#bk2-checkout-btn') || U.$('#bk2-sticky-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Tilføjer...'; }

    /* Collect delivery address */
    if (S.fulfillment === 'delivery') {
      var parts = [];
      var addr = U.$('#bk2-delivery-street'), apt = U.$('#bk2-delivery-apt'), city = U.$('#bk2-delivery-city');
      if (addr && addr.value.trim()) parts.push(addr.value.trim());
      if (apt && apt.value.trim()) parts.push(apt.value.trim());
      if (city && city.value.trim()) parts.push(city.value.trim());
      else if (S.postalCity) parts.push(S.postalCode + ' ' + S.postalCity);
      S.deliveryAddress = parts.join(', ');
    }

    cart.setLineItemProps();

    var form = U.$('form[action*="/cart/add"]');
    if (!form) {
      /* Previously this silently returned and left the button stuck on
       * "Tilføjer...". Surface a real error so the user knows to reload. */
      var b0 = U.$('#bk2-checkout-btn') || U.$('#bk2-sticky-btn');
      if (b0) { b0.disabled = false; b0.textContent = 'Book nu'; }
      alert('Bookingformularen kunne ikke findes. Genindlæs siden og prøv igen.');
      return;
    }
    var fd = new FormData(form);
    var mainItem = {};
    fd.forEach(function(val, key) {
      if (key === 'id') mainItem.id = parseInt(val);
      else if (key === 'quantity') mainItem.quantity = parseInt(val) || 1;
      else if (key.indexOf('properties[') === 0) {
        if (!mainItem.properties) mainItem.properties = {};
        mainItem.properties[key.replace('properties[', '').replace(']', '')] = val;
      }
    });
    if (!mainItem.quantity) mainItem.quantity = 1;

    /* The form's `id` is set by Shopify's variant-radios component. If the
     * user landed on a variantless URL or the picker hasn't wired up yet
     * (race), id is NaN and we used to POST `{"id":null,...}` to Shopify —
     * which 404s and serves an HTML error page, surfacing as
     * "Unexpected token '<', '<!DOCTYPE'..." in the user's alert. Catch it
     * here with a clear actionable message instead. */
    if (!mainItem.id || isNaN(mainItem.id)) {
      var b1 = U.$('#bk2-checkout-btn') || U.$('#bk2-sticky-btn');
      if (b1) { b1.disabled = false; b1.textContent = 'Book nu'; }
      console.error('[BaskasRental] Missing variant id on cart submit', { form: form, mainItem: mainItem });
      ui.showError('Vælg model og antal, før du booker.');
      return;
    }

    var addonItems = [];
    for (var vid in S.selectedAddons) addonItems.push({ id: parseInt(vid), quantity: S.selectedAddons[vid] });

    /* Add delivery fee as a line item if delivery is selected and not free */
    var deliveryCost = cart.getDeliveryCost();
    if (S.fulfillment === 'delivery' && deliveryCost > 0) {
      addonItems.push({ id: 57034517676363, quantity: 1 });
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* credentials:same-origin is the spec default but Safari (esp. in private
     * mode) has shipped buggy implementations; being explicit guarantees the
     * Shopify _shopify_y / cart session cookie ride along. */
    var FETCH_OPTS = { credentials: 'same-origin' };

    /* Hard timeout: a hanging mobile request would lock the button as
     * "Tilføjer..." forever. 20s is generous enough for slow 3G + Shopify
     * cold-start but bounded enough that the user can retry. */
    function withTimeout(p, ms) {
      return new Promise(function(resolve, reject) {
        var timer = setTimeout(function() {
          reject(new Error('Tidsudløb — tjek din internetforbindelse'));
        }, ms);
        p.then(function(v) { clearTimeout(timer); resolve(v); },
               function(e) { clearTimeout(timer); reject(e); });
      });
    }

    /* Explicit Accept header forces Shopify to return JSON. Without it, iOS
     * Safari (ITP) can lose the session cookie between cart/clear and
     * cart/add, in which case Shopify redirects to set a new one and the
     * final body is HTML. r.json() then throws WebKit's
     * "The string did not match the expected pattern", which we used to
     * surface verbatim to the user. */
    var JSON_HEADERS = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    /* Parse response defensively: if the body isn't JSON (HTML redirect,
     * empty body, bot challenge page), log it for debugging and throw a
     * Danish error the user can act on. */
    function readJson(r) {
      return r.text().then(function(text) {
        var data = null;
        if (text) {
          try { data = JSON.parse(text); } catch (e) {
            console.error('[BaskasRental] cart/add returned (first 500):', text.slice(0, 500));
            throw new Error('Serveren svarede uventet. Genindlæs siden og prøv igen.');
          }
        }
        if (!r.ok || (data && data.status && data.status >= 400)) {
          throw new Error((data && data.description) || ('HTTP ' + r.status));
        }
        return data;
      });
    }

    /* Atomic cart replace — Baskas is single-flow rental only, so the
     * cart should contain just the new booking. Read /cart.js; if anything
     * is there, zero those variants via cart/update.js (gentler on iOS
     * Safari ITP than cart/clear.js was). Then add the new rental + addons
     * via cart/add.js — the only POST shape that accepts per-line-item
     * properties (rental_date, addons, etc.). On any failure, fire
     * cart/clear.js defensively so the next attempt starts clean. */
    ui.hideError();

    function clearExistingItems() {
      return fetch(root + 'cart.js', Object.assign({
        method: 'GET', headers: JSON_HEADERS
      }, FETCH_OPTS))
        .then(readJson)
        .then(function(currentCart) {
          if (!currentCart || !currentCart.items || !currentCart.items.length) {
            return null;
          }
          var updates = {};
          currentCart.items.forEach(function(it) {
            var k = it.variant_id || it.id;
            if (k) updates[k] = 0;
          });
          return fetch(root + 'cart/update.js', Object.assign({
            method: 'POST', headers: JSON_HEADERS,
            body: JSON.stringify({ updates: updates })
          }, FETCH_OPTS)).then(readJson);
        });
    }

    withTimeout(
      clearExistingItems()
        .then(function() {
          return fetch(root + 'cart/add.js', Object.assign({
            method: 'POST', headers: JSON_HEADERS,
            body: JSON.stringify({ items: [mainItem].concat(addonItems) })
          }, FETCH_OPTS));
        })
        .then(readJson)
        .then(function() {
          window.location.href = root + 'checkout';
        }),
      20000
    ).catch(function(err) {
      console.error('[BaskasRental] Checkout failed:', err);
      var b = U.$('#bk2-checkout-btn') || U.$('#bk2-sticky-btn');
      if (b) { b.disabled = false; b.textContent = 'Book nu'; }
      ui.showError('Kunne ikke gå til checkout: ' + (err.message || 'Ukendt fejl'));
      /* Defensive: prevent a half-populated cart from polluting next attempt */
      fetch(root + 'cart/clear.js', Object.assign({
        method: 'POST', headers: JSON_HEADERS
      }, FETCH_OPTS)).catch(function() {});
    });
  };

  cart.updateBuyButtons = function() {
    U.$$('.product-form__add .js-product-add,.product-form__add-btn:not(.skeleton-button)').forEach(function(b) {
      b.style.display = 'none';
    });
    var db = U.$('.product-form__add--dynamic');
    var pb = U.$('.shopify-payment-button');
    if (db) db.style.display = 'none';
    if (pb) pb.style.display = 'none';
  };


  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 6: UI — rendering, fulfillment, summary, sticky bar
   * ═══════════════════════════════════════════════════════════════════ */

  var ui = BR.ui = {};

  ui.isFestivalProduct = function() {
    return (document.body && document.body.className.indexOf('festival') !== -1) ||
      location.pathname.indexOf('festival') !== -1;
  };

  /* ── Step show/hide (legacy — kept for compatibility) ──────────── */
  ui.showStep = function(id) {
    var el = U.$('#' + id, S.container);
    if (el) el.classList.remove('bk2__step--hidden');
  };

  ui.hideStep = function(id) {
    var el = U.$('#' + id, S.container);
    if (el) el.classList.add('bk2__step--hidden');
  };

  /* ── Error banner (replaces native alert()) ────────────────────────── */
  var ERROR_BANNER_ID = 'bk2-error-banner';
  var ERROR_MSG_ID = 'bk2-error-msg';
  var ERROR_CLOSE_ID = 'bk2-error-close';

  ui.showError = function(msg) {
    var banner = U.$('#' + ERROR_BANNER_ID, S.container);
    var msgEl = U.$('#' + ERROR_MSG_ID, S.container);
    if (!banner || !msgEl) { /* fallback if banner not rendered yet */
      console.error('[BaskasRental] ' + msg);
      return;
    }
    msgEl.textContent = msg;
    banner.style.display = 'flex';
  };

  ui.hideError = function() {
    var banner = U.$('#' + ERROR_BANNER_ID, S.container);
    if (banner) banner.style.display = 'none';
  };

  /* ── Step state manager (replaces sequential show/hide) ────────── */
  var _syncDebounce = null;
  var _syncRunning = false;
  ui.syncStepStates = function() {
    if (_syncRunning) return; /* Prevent recursion */
    if (_syncDebounce) return;
    _syncDebounce = setTimeout(function() { _syncDebounce = null; ui._doSyncStepStates(); }, 30);
  };

  ui._doSyncStepStates = function() {
    if (_syncRunning) return;
    _syncRunning = true;
    try {
    var hasDate = !!S.eventDate;
    var hasModel = !!S.model;
    var hasPostal = S.postalCode && S.postalCode.length === 4;
    var hasFulfill = !!S.fulfillment;
    var hasWindow = hasFulfill && !!S.selectedWindow;
    var isComplete = ui.isBookingComplete();

    var steps = [
      { id: 'bk2-step-addons',  active: hasDate && hasModel, done: false,
        hint: 'V\u00e6lg en dato f\u00f8rst' },
      { id: 'bk2-step-fulfill', active: hasDate, done: hasFulfill,
        hint: 'V\u00e6lg en dato f\u00f8rst' },
      { id: 'bk2-step-period',  active: hasFulfill, done: hasWindow,
        hint: 'V\u00e6lg afhentning eller levering f\u00f8rst' },
      { id: 'bk2-step-contact', active: hasWindow, done: hasWindow,
        hint: 'V\u00e6lg lejeperiode f\u00f8rst' },
      { id: 'bk2-step-summary', active: isComplete, done: false,
        hint: 'Udfyld alle trin ovenfor' },
    ];

    /* Postal section — once opened, stays open (user explicitly clicked delivery teaser) */
    var postalSec = U.$('#bk2-postal-section', S.container);
    if (postalSec && postalSec.style.display === 'block') {
      /* Already open — don't hide it */
    } else if (postalSec && S.fulfillment === 'delivery') {
      postalSec.style.display = 'block';
    }

    for (var i = 0; i < steps.length; i++) {
      var el = U.$('#' + steps[i].id, S.container);
      if (!el) continue;

      el.classList.remove('bk2__step--hidden', 'bk2__step--locked', 'bk2__step--active', 'bk2__step--done');

      if (steps[i].done) {
        el.classList.add('bk2__step--done');
      } else if (steps[i].active) {
        el.classList.add('bk2__step--active');
      } else {
        el.classList.add('bk2__step--locked');
      }

      /* Update or create hint element */
      var hint = el.querySelector('.bk2__step-hint');
      if (!steps[i].active && steps[i].hint) {
        if (!hint) {
          hint = document.createElement('div');
          hint.className = 'bk2__step-hint';
          el.appendChild(hint);
        }
        hint.textContent = steps[i].hint;
        hint.style.display = '';
      } else if (hint) {
        hint.style.display = 'none';
      }
    }

    /* Update summary + sticky bar */
    if (isComplete) {
      ui.renderSummary();
      cart.setLineItemProps();
    }
    /* Always update BOTH book buttons: the summary card one lives inside
     * S.container, but the sticky bar is appended to <body>. Querying just
     * S.container would miss the sticky button and leave the two CTAs out
     * of sync — visible-but-disabled is the worst UX. */
    var summaryBtn = U.$('#bk2-checkout-btn', S.container);
    if (summaryBtn) summaryBtn.disabled = !isComplete;
    var stickyBtn = document.getElementById('bk2-sticky-btn');
    if (stickyBtn) stickyBtn.disabled = !isComplete;
    } finally { _syncRunning = false; }
  };

  ui.isBookingComplete = function() {
    var deliveryOk = S.postalCode.length === 4 && S.postalDeliverable && S.deliveryAddress;
    return S.eventDate && S.model && S.selectedWindow &&
      S.fulfillment &&
      (S.fulfillment !== 'pickup' || S.pickupLocation) &&
      (S.fulfillment !== 'delivery' || deliveryOk);
  };

  /* ── Inject step numbers + upsell + value stack into variant picker ── */
  ui.injectVariantSteps = function() {
    var vpBlock = U.$('.product-single__box__block--variant_picker');
    if (!vpBlock || vpBlock.dataset.bkDone) return;
    vpBlock.dataset.bkDone = '1';
    vpBlock.classList.add('bk2__step', 'bk2__step--injected');

    var fs = U.$$('fieldset.product-form__swatch', vpBlock);

    /* Replace fieldset legends with matching bk2 step headers */
    var stepLabels = [
      { num: '2', title: 'Vælg model' },
      { num: '3', title: 'Antal' }
    ];
    for (var i = 0; i < Math.min(fs.length, stepLabels.length); i++) {
      var titleWrap = U.$('.product-form__swatch__title', fs[i]);
      if (titleWrap && !titleWrap.dataset.bkBadge) {
        titleWrap.dataset.bkBadge = '1';
        titleWrap.innerHTML = '<div class="bk2__step-head" style="margin-bottom:0">' +
          '<span class="bk2__step-num">' + stepLabels[i].num + '</span>' +
          '<span class="bk2__step-title">' + stepLabels[i].title + '</span>' +
        '</div>';
      }
    }

    /* Append upsell + value stack below Antal fieldset */
    if (fs.length >= 2) {
      var u = document.createElement('div'); u.id = 'bk2-antal-upsell'; fs[1].appendChild(u);
      var v = document.createElement('div'); v.id = 'bk2-value-stack'; fs[1].appendChild(v);
    }

    var qb = U.$('.product-single__box__block--quantity_selector');
    if (qb) qb.style.display = 'none';
  };

  /* ── Upsell (below quantity buttons) ───────────────────────────── */
  ui.renderAntalUpsell = function() { return; /* Disabled — clutters mobile form */
    var wrap = document.getElementById('bk2-antal-upsell');
    if (!wrap) return;
    if (S.model === 'SB2') { wrap.innerHTML = ''; return; }

    var upsell = getUpsell();
    var tier = upsell[S.quantity] || (S.quantity >= 3 ? upsell[3] : null);

    if (!tier && S.quantity === 1) {
      var next = upsell[2];
      wrap.innerHTML = next
        ? '<div class="bk2__upsell-hint"><span class="bk2__upsell-hint-tag">' + next.tag + '</span> Vælg 2 speakers og få: ' + next.perks[0].toLowerCase() + '</div>'
        : '';
      return;
    }
    if (!tier) { wrap.innerHTML = ''; return; }

    var html = '<div class="bk2__upsell-box">';
    if (tier.tag) html += '<span class="bk2__upsell-tag">' + tier.tag + '</span>';
    html += '<div class="bk2__upsell-perks">';
    for (var j = 0; j < tier.perks.length; j++) {
      html += '<div class="bk2__upsell-perk">' + BR.CHK + '<span>' + tier.perks[j] + '</span></div>';
    }
    html += '</div>';
    if (tier.msg) html += '<p class="bk2__upsell-msg">' + tier.msg + '</p>';
    wrap.innerHTML = html + '</div>';
  };

  /* ── Value stack (below quantity buttons) ──────────────────────── */
  ui.renderValueStack = function() { return; /* Disabled — info is in the summary instead */
    var wrap = document.getElementById('bk2-value-stack');
    if (!wrap) return;
    var labels = getLabels();
    var model = labels[S.model] || S.model;
    var perUnit = S.quantity > 1 ? ' pr. speaker' : '';

    wrap.innerHTML = '<div class="bk2__vstack">' +
      '<div class="bk2__vstack-title">Alt dette er inkluderet' + perUnit + ':</div>' +
      '<div class="bk2__vstack-grid">' +
        '<div class="bk2__vstack-item">' + BR.CHK + '100% forsikring (0 kr. selvrisiko)</div>' +
        '<div class="bk2__vstack-item">' + BR.CHK + '0 kr. depositum</div>' +
        '<div class="bk2__vstack-item">' + BR.CHK + 'Ekstra batteri gratis</div>' +
        '<div class="bk2__vstack-item">' + BR.CHK + 'AUX adapter</div>' +
        '<div class="bk2__vstack-item">' + BR.CHK + 'AirTag sporing</div>' +
        '<div class="bk2__vstack-item">' + BR.CHK + '24/7 support</div>' +
      '</div>' +
      (S.quantity > 1 ? '<div class="bk2__vstack-total">' + S.quantity + 'x ' + model + ' — alt inkluderet, én samlet pris</div>' : '') +
    '</div>';
  };

  /* ── Delivery progress bar ─────────────────────────────────────── */
  ui.renderDeliveryProgress = function() {
    var total = BR.getVariantPrice() + addons.getTotal();
    var r = getDeliveryRules();
    var threshold = r.free_threshold || 1000;
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, (total / threshold) * 100);
    var free = remaining <= 0;

    return '<div class="bk2__delivery-progress">' +
      '<div class="bk2__delivery-bar' + (free ? ' bk2__delivery-bar--free' : '') + '">' +
      '<div class="bk2__delivery-bar-fill" style="width:' + pct + '%"></div></div>' +
      '<div class="bk2__delivery-msg' + (free ? ' bk2__delivery-msg--free' : '') + '">' +
      (free ? '\u2713 Gratis levering!' : 'Tilføj for ' + Math.ceil(remaining) + ' kr. mere for gratis levering') +
      '</div></div>';
  };

  ui.updateDeliveryProgress = function() {
    U.$$('.bk2__delivery-progress-wrap').forEach(function(w) { w.innerHTML = ui.renderDeliveryProgress(); });
  };

  /* ── Render calendar into calWrap (ABOVE variant picker) ──────── */
  ui.renderCalendar = function() {
    if (!S.calWrap) return;
    S.calWrap.innerHTML =
      '<div class="bk2"><div class="bk2__step" id="bk2-step-cal">' +
        '<div class="bk2__step-head"><span class="bk2__step-num">1</span><span class="bk2__step-title">Hvornår er din fest?</span></div>' +
        '<div class="bk2__calendar" id="bk2-calendar"></div>' +
        '<div class="bk2__date-feedback" id="bk2-date-feedback"></div>' +
      '</div></div>';
  };

  /* ── Render rest of flow into container (BELOW variant picker) ── */
  ui.renderFlow = function(container) {
    container.innerHTML = '<div class="bk2">' +

      /* Step 4: Add-ons */
      '<div class="bk2__step bk2__step--locked" id="bk2-step-addons">' +
        '<div class="bk2__step-head"><span class="bk2__step-num">4</span><span class="bk2__step-title">Tilføj tilbehør</span><span class="bk2__step-optional">Valgfrit</span></div>' +
        '<div id="bk2-addons-list"></div>' +
      '</div>' +

      /* Step 5: Fulfillment (pickup or delivery — postal only needed for delivery) */
      '<div class="bk2__step bk2__step--locked" id="bk2-step-fulfill">' +
        '<div class="bk2__step-head"><span class="bk2__step-num">5</span><span class="bk2__step-title">Afhentning eller levering?</span></div>' +
        '<div id="bk2-fulfill-options" class="bk2__fulfill-options"></div>' +
        '<div id="bk2-postal-section" style="margin-top:14px;padding-top:14px;border-top:1px solid #e7e5e4;display:none;">' +
          '<div style="font-size:14px;font-weight:600;color:#1a1a1a;margin-bottom:4px;">Vil du have leveret? <span style="color:#16a34a;font-weight:600;">(Gratis over 1.000 kr.)</span></div>' +
          '<div style="font-size:13px;color:#78716c;margin-bottom:8px;">Indtast postnummer for at tjekke om vi leverer til dig</div>' +
          '<div class="bk2__postal-input-wrap">' +
            '<input type="text" id="bk2-postal-input" class="bk2__postal-input" placeholder="Postnummer" maxlength="4" inputmode="numeric" pattern="[0-9]*" style="font-size:16px;padding:12px 16px;width:100%;">' +
            '<div id="bk2-postal-result" class="bk2__postal-result"></div>' +
          '</div>' +
        '</div>' +
        '<div id="bk2-delivery-form" class="bk2__delivery-form" style="display:none;">' +
          '<div class="bk2__delivery-field"><label for="bk2-delivery-street">Adresse</label>' +
            '<input type="text" id="bk2-delivery-street" class="bk2__extra-input" placeholder="Gadenavn og nr."></div>' +
          '<div class="bk2__delivery-field"><label for="bk2-delivery-apt">Lejlighed / dør</label>' +
            '<input type="text" id="bk2-delivery-apt" class="bk2__extra-input" placeholder="Valgfrit"></div>' +
          '<div class="bk2__delivery-field"><label for="bk2-delivery-city">By</label>' +
            '<input type="text" id="bk2-delivery-city" class="bk2__extra-input" placeholder="By"></div>' +
        '</div>' +
      '</div>' +

      /* Period (auto-calculated from event date + fulfillment) */
      '<div class="bk2__step bk2__step--locked" id="bk2-step-period">' +
        '<div class="bk2__step-head"><span class="bk2__step-title">Lejeperiode</span></div>' +
        '<div class="bk2__value-banner">' +
          '<div class="bk2__value-item">' + BR.CHK + '<span>Samme pris uanset varighed</span></div>' +
          '<div class="bk2__value-item">' + BR.CHK + '<span>Vælg den periode der passer dig</span></div>' +
          '<div class="bk2__value-item">' + BR.CHK + '<span>Du betaler for lyden, ikke for dagene</span></div>' +
        '</div>' +
        '<div id="bk2-period-options"></div>' +
      '</div>' +

      /* Step 7: Contact + Extra */
      '<div class="bk2__step bk2__step--locked" id="bk2-step-contact">' +
        '<div class="bk2__step-head"><span class="bk2__step-num">7</span><span class="bk2__step-title">Kontakt + Ekstra info</span></div>' +
        '<div style="margin-bottom:14px;">' +
          '<span style="font-size:13px;font-weight:600;color:var(--color--text,#44403c);margin-bottom:6px;display:block;">Kontakt mig via</span>' +
          '<div class="bk2__contact-toggle">' +
            '<label class="bk2__contact-opt bk2__contact-opt--active" data-value="sms"><input type="radio" name="bk2-contact" value="sms" checked>SMS</label>' +
            '<label class="bk2__contact-opt" data-value="opkald"><input type="radio" name="bk2-contact" value="opkald">Opkald</label>' +
          '</div>' +
        '</div>' +
        '<div class="bk2__extra-fields">' +
          '<div class="bk2__extra-field">' +
            '<label class="bk2__extra-label" for="bk2-event-type">Hvad skal udstyret bruges til?</label>' +
            '<select id="bk2-event-type" class="bk2__extra-input bk2__extra-select">' +
              '<option value="">Vælg type...</option>' +
              '<option value="Privatfest">Privatfest</option>' +
              '<option value="Firma-event">Firma-event</option>' +
              '<option value="Festival">Festival</option>' +
              '<option value="Polterabend">Polterabend</option>' +
              '<option value="Fødselsdag">Fødselsdag</option>' +
              '<option value="Konfirmation">Konfirmation</option>' +
              '<option value="Andet">Andet</option>' +
            '</select>' +
          '</div>' +
          '<div class="bk2__extra-field">' +
            '<label class="bk2__extra-label" for="bk2-comment">Noget vi skal vide?</label>' +
            '<textarea id="bk2-comment" class="bk2__extra-textarea" rows="2" placeholder="Særlige ønsker, leveringsdetaljer, spørgsmål..."></textarea>' +
          '</div>' +
        '</div>' +
      '</div>' +

      /* Step 8: Summary */
      '<div class="bk2__step bk2__step--locked" id="bk2-step-summary">' +
        '<div class="bk2__step-head"><span class="bk2__step-num">8</span><span class="bk2__step-title">Opsummering</span></div>' +
        '<div class="bk2__summary" id="bk2-summary"></div>' +
      '</div>' +

      /* Error banner (hidden by default, shown on checkout failures) */
      '<div id="bk2-error-banner" class="bk2__error-banner" style="display:none">' +
        '<span class="bk2__error-banner-msg" id="bk2-error-msg"></span>' +
        '<button type="button" class="bk2__error-banner-close" id="bk2-error-close" aria-label="Luk">\u00d7</button>' +
      '</div>' +

      /* Fallback contact card */
      '<div class="bk2__fallback">Passer dagene ikke? Kontakt os — vi finder altid en løsning' +
        '<div class="bk2__fallback-links">SMS: <a href="sms:26771774">26 77 17 74</a> · <a href="mailto:kontakt@baskas.dk">kontakt@baskas.dk</a></div>' +
      '</div>' +

    '</div>';

    ui.initContact();
    ui.initPostalCode();
    ui.initContactFields();

    /* Wire error banner close button */
    var closeBtn = U.$('#bk2-error-close', S.container);
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        ui.hideError();
      });
    }
  };

  /* ── Fulfillment cards (dynamic from config) ───────────────────── */
  ui.renderFulfillment = function() {
    var wrap = U.$('#bk2-fulfill-options', S.container);
    if (!wrap) return;
    var locations = getLocations();
    var rules = getDeliveryRules();
    var evtDs = S.eventDate ? U.fmtDate(S.eventDate) : null;
    var html = '';

    /* Pickup cards — one per location */
    for (var li = 0; li < locations.length; li++) {
      var loc = locations[li];
      var isSel = S.fulfillment === 'pickup' && S.pickupLocation === loc.id;
      var mapsUrl = 'https://maps.google.com/?q=' + encodeURIComponent(loc.address || loc.name);
      html += '<label class="bk2__fulfill-card' + (isSel ? ' bk2__fulfill-card--active' : '') + '" data-value="pickup" data-location="' + loc.id + '">' +
        '<input type="radio" name="bk2-fulfill" value="pickup" data-location="' + loc.id + '"' + (isSel ? ' checked' : '') + '>' +
        '<div class="bk2__fulfill-body">' +
          '<strong>Afhentning — ' + U.esc(loc.name) + '</strong>' +
          '<span class="bk2__fulfill-price">Gratis</span>' +
          '<span class="bk2__fulfill-detail">' + U.esc(loc.address || '') + '</span>' +
          '<span class="bk2__fulfill-detail">' + U.esc(loc.hours || 'Man & tor kl. 16–21') + '</span>' +
          '<a href="' + mapsUrl + '" target="_blank" rel="noopener" class="bk2__fulfill-map-link">Se på kort</a>' +
          '<span class="bk2__fulfill-detail bk2__fulfill-note">Vi kontakter dig for at aftale tidspunkt.</span>' +
        '</div></label>';
    }

    /* Delivery card */
    var cost = rules.cost || 395;
    var threshold = rules.free_threshold || 1000;
    if (S.postalDeliverable) {
      var isDel = S.fulfillment === 'delivery';
      html += '<label class="bk2__fulfill-card' + (isDel ? ' bk2__fulfill-card--active' : '') + '" data-value="delivery">' +
        '<input type="radio" name="bk2-fulfill" value="delivery"' + (isDel ? ' checked' : '') + '>' +
        '<div class="bk2__fulfill-body">' +
          '<strong>Levering til ' + U.esc(S.postalCity || 'din adresse') + '</strong>' +
          '<span class="bk2__fulfill-price">' + cost + ' kr. <span class="bk2__fulfill-free">(gratis over ' + threshold + ' kr.)</span></span>' +
          '<div class="bk2__delivery-progress-wrap">' + ui.renderDeliveryProgress() + '</div>' +
          '<span class="bk2__fulfill-detail">Vi leverer fredag kl. 17\u201321, henter s\u00f8ndag kl. 17\u201321</span>' +
        '</div></label>';
    } else {
      /* No delivery available (or not checked yet) — show teaser to enter/change postal code */
      var teaserMsg = (S.postalCode.length === 4 && S.postalDeliverable === false)
        ? 'Vi leverer ikke til ' + U.esc(S.postalCity || S.postalCode) + ' \u2014 pr\u00f8v et andet postnummer'
        : 'Indtast postnummer for at tjekke \u2192';
      html += '<div class="bk2__fulfill-card bk2__fulfill-card--teaser" id="bk2-delivery-teaser" style="cursor:pointer;text-align:center;padding:16px;">' +
        '<div class="bk2__fulfill-body">' +
          '<strong>Levering</strong>' +
          '<span class="bk2__fulfill-price">' + cost + ' kr. <span class="bk2__fulfill-free">(gratis over ' + threshold + ' kr.)</span></span>' +
          '<span class="bk2__fulfill-detail" style="color:#fa4619;font-weight:600;">' + teaserMsg + '</span>' +
        '</div></div>';
    }

    wrap.innerHTML = html;

    /* Auto-select pickup — prefer Stjernepladsen as default */
    var defaultLoc = locations.find(function(l) { return l.id === 'stjernepladsen'; }) || locations[0];
    if (!S.pickupLocation && defaultLoc) {
      S.pickupLocation = defaultLoc.id;
      S.fulfillment = 'pickup';
      var fc = U.$('.bk2__fulfill-card[data-location="' + defaultLoc.id + '"]', wrap);
      if (fc) fc.classList.add('bk2__fulfill-card--active');
      var fr = fc && fc.querySelector('input[name="bk2-fulfill"]');
      if (fr) fr.checked = true;
      /* Auto-selected — trigger downstream immediately */
      ui._fetchAndShowWindows();
      ui.syncStepStates();
    }

    /* Bind fulfillment handlers */
    U.$$('input[name="bk2-fulfill"]', wrap).forEach(function(r) {
      r.addEventListener('change', function() {
        S.fulfillment = r.value;
        S.pickupLocation = r.value === 'pickup' ? (r.dataset.location || null) : null;
        U.$$('.bk2__fulfill-card', wrap).forEach(function(c) {
          var match = r.value === 'pickup'
            ? (c.dataset.value === 'pickup' && c.dataset.location === r.dataset.location)
            : c.dataset.value === 'delivery';
          c.classList.toggle('bk2__fulfill-card--active', match);
        });
        var df = U.$('#bk2-delivery-form', S.container);
        if (df) df.style.display = r.value === 'delivery' ? 'block' : 'none';
        /* Show/hide postal section based on delivery selection */
        var postalSec = U.$('#bk2-postal-section', S.container);
        if (postalSec) postalSec.style.display = r.value === 'delivery' ? 'block' : 'none';
        /* Fulfillment chosen → fetch availability and show period/contact/summary */
        ui._fetchAndShowWindows();
        ui.updateDeliveryProgress();
        ui.updateStickyBar();
        ui.syncStepStates();
      });
    });

    /* Delivery teaser click → reveal postal input (use delegation — survives re-renders) */
    wrap.addEventListener('click', function(ev) {
      var teaser = ev.target.closest('#bk2-delivery-teaser');
      if (teaser) {
        var postalSec = U.$('#bk2-postal-section', S.container);
        if (postalSec) {
          postalSec.style.display = 'block';
          var inp = U.$('#bk2-postal-input', S.container);
          if (inp) inp.focus();
        }
      }
    });

    /* Location stock fetch removed — stock labels are no longer shown on fulfillment cards */
  };

  /* ── Recalculate rental windows ────────────────────────────────── */
  ui.recalculateWindows = function() {
    if (!S.eventDate) return;
    var fb = U.$('#bk2-date-feedback', S.calWrap) || U.$('#bk2-date-feedback');
    var windows = cal.calculateWindows(S.eventDate, S.fulfillment);

    if (windows.length === 0) {
      S.selectedWindow = null;
      ui.hideStep('bk2-step-period');
      ui.hideStep('bk2-step-contact');
      ui.hideStep('bk2-step-summary');
      cart.removeLineItemProps();
      cart.updateBuyButtons();
      var reason = cal.diagnoseNoWindows(S.eventDate, S.fulfillment);
      var msgs = {
        blocked:  ['Denne dato er ikke tilgængelig', 'Datoen er reserveret til et event. Kontakt os for mere info.', 'warn'],
        festival: ['Festivalperiode', 'Denne periode er reserveret til festival-udlejning. Tryk p\u00e5 datoen for at se hvilken festival.', 'warn'],
        soldout:  ['Udsolgt på denne dato', 'Alle enheder er booket. Prøv en anden dato.', 'warn'],
        toosoon:  ['For tæt på', 'Kontakt os — vi kan ofte finde en løsning.', 'info'],
        nowindow: ['Ingen ledige perioder', 'Prøv en anden dato eller kontakt os.', 'info']
      };
      var m = msgs[reason] || msgs.nowindow;
      if (fb) fb.innerHTML = '<div class="bk2__feedback bk2__feedback--' + m[2] + '">' + BR.WARN + '<div><strong>' + m[0] + '</strong><p>' + m[1] + '</p></div></div>';
      return;
    }

    if (fb) fb.innerHTML = '';
    S.selectedWindow = windows[0];
    cal.render();
    ui.renderPeriodOptions(windows);
    addons.render();
    ui.syncStepStates();
    ui.updateStickyBar();
  };

  /* ── Period options ────────────────────────────────────────────── */
  ui.renderPeriodOptions = function(windows) {
    var wrap = U.$('#bk2-period-options', S.container);
    if (!wrap) return;
    var html = '';

    for (var i = 0; i < windows.length; i++) {
      var w = windows[i];
      var sel = S.selectedWindow && U.sameDay(w.start, S.selectedWindow.start) && U.sameDay(w.end, S.selectedWindow.end);
      var pL = S.fulfillment === 'delivery' ? 'Levering' : 'Afhent';
      var rL = S.fulfillment === 'delivery' ? 'Hentes' : 'Aflever';
      html += '<label class="bk2__period-card' + (sel ? ' bk2__period-card--active' : '') + '" data-idx="' + i + '">' +
        '<input type="radio" name="bk2-period" value="' + i + '"' + (sel ? ' checked' : '') + '>' +
        '<div class="bk2__period-body">' +
          '<div class="bk2__period-dates">' + U.fmtShort(w.start) + ' \u2192 ' + U.fmtShort(w.end) + '</div>' +
          '<div class="bk2__period-detail">' + pL + ' ' + BR.DAY_NAMES[w.start.getDay()] + ' · ' + rL + ' ' + BR.DAY_NAMES[w.end.getDay()] + '</div>' +
        '</div></label>';
    }
    wrap.innerHTML = html;
    wrap._windows = windows;

    U.$$('.bk2__period-card', wrap).forEach(function(card) {
      card.addEventListener('click', function() {
        S.selectedWindow = wrap._windows[parseInt(card.dataset.idx)];
        U.$$('.bk2__period-card', wrap).forEach(function(c) {
          c.classList.toggle('bk2__period-card--active', c === card);
        });
        cal.render();
        ui.renderSummary();
        ui.updateStickyBar();
        cart.setLineItemProps();
      });
    });
  };

  /* ── Summary (Step 8) ──────────────────────────────────────────── */
  ui.renderSummary = function() {
    var wrap = U.$('#bk2-summary', S.container);
    if (!wrap || !S.selectedWindow) return;
    var w = S.selectedWindow;
    var labels = getLabels();
    var locations = getLocations();
    var basePrice = BR.getVariantPrice();
    var addonTotal = addons.getTotal();
    var deliveryCost = cart.getDeliveryCost();
    var totalPrice = basePrice + addonTotal + deliveryCost;
    var days = Math.ceil((w.end - w.start) / (1000 * 60 * 60 * 24)) + 1;

    var html = '<h3 class="bk2__summary-title">Din booking</h3><div class="bk2__summary-section">';

    /* Speaker */
    html += '<div class="bk2__summary-row">' + BR.CHK + '<span>' + S.quantity + 'x ' + (labels[S.model] || S.model) + '</span>' +
      '<span class="bk2__summary-price">' + U.fmtPrice(basePrice) + '</span></div>';

    /* Period */
    html += '<div class="bk2__summary-row">' + BR.CHK + '<span>Lejeperiode: ' + U.fmtShort(w.start) + ' \u2192 ' + U.fmtShort(w.end) + ' (' + days + ' dage)</span></div>';

    /* Event date */
    if (S.eventDate) {
      var evtStr = U.fmtShort(S.eventDate);
      if (S.eventEndDate) evtStr += ' \u2192 ' + U.fmtShort(S.eventEndDate);
      html += '<div class="bk2__summary-row">' + BR.CHK + '<span>Fest: ' + evtStr + '</span></div>';
    }

    /* Addons */
    for (var vid in S.selectedAddons) {
      for (var i = 0; i < S.addons.length; i++) {
        if (String(S.addons[i].variantId) === String(vid)) {
          var q = S.selectedAddons[vid];
          var lp = S.addons[i].price * q;
          html += '<div class="bk2__summary-row">' + BR.CHK + '<span>' + (q > 1 ? q + 'x ' : '') + U.esc(S.addons[i].title) + '</span>' +
            '<span class="bk2__summary-price">' + U.fmtPrice(lp) + '</span></div>';
        }
      }
    }

    /* Fulfillment */
    if (S.fulfillment === 'delivery') {
      var cityName = U.esc(S.postalCity || 'din adresse');
      html += '<div class="bk2__summary-row' + (deliveryCost > 0 ? ' bk2__summary-row--note' : '') + '">' + BR.CHK +
        '<span>Levering til ' + cityName + '<br><small>Fredag kl. 17–21 ud, søndag kl. 17–21 retur</small></span>' +
        '<span class="bk2__summary-price' + (deliveryCost > 0 ? ' bk2__summary-price--note' : ' bk2__summary-price--free') + '">' +
        (deliveryCost > 0 ? '+' + U.fmtPrice(deliveryCost) : 'Gratis') + '</span></div>';
      html += '<div class="bk2__delivery-progress-wrap">' + ui.renderDeliveryProgress() + '</div>';
    } else {
      var pickupLoc = null;
      for (var pl = 0; pl < locations.length; pl++) {
        if (locations[pl].id === S.pickupLocation) { pickupLoc = locations[pl]; break; }
      }
      if (!pickupLoc && locations.length) pickupLoc = locations[0];
      if (pickupLoc) {
        html += '<div class="bk2__summary-row">' + BR.CHK + '<span>Afhentning: ' + U.esc(pickupLoc.name) +
          '<br><small>' + U.esc(pickupLoc.address || '') + ' · ' + U.esc(pickupLoc.hours || 'Man & tor kl. 16–21') + '</small></span>' +
          '<span class="bk2__summary-price bk2__summary-price--free">Gratis</span></div>';
      }
    }

    /* Contact + postal */
    html += '<div class="bk2__summary-row">' + BR.CHK + '<span>Kontakt: ' + (S.contact === 'sms' ? 'SMS' : 'Opkald') + '</span></div>';
    if (S.postalCode) {
      html += '<div class="bk2__summary-row">' + BR.CHK + '<span>Postnummer: ' + U.esc(S.postalCode) +
        (S.postalCity ? ' ' + U.esc(S.postalCity) : '') + '</span></div>';
    }
    html += '</div>';

    /* Total + included + button */
    html += '<div class="bk2__summary-total"><span>Total</span><span>' + U.fmtPrice(totalPrice) + '</span></div>';
    html += '<div class="bk2__summary-included">Inkluderet: 100% forsikring (0 kr. selvrisiko) · 0 kr. depositum · ekstra batteri · AUX adapter · AirTag sporing · 24/7 support</div>';
    html += '<button type="button" id="bk2-checkout-btn" class="bk2__book-btn" onclick="window.BaskasRental.cart.onCheckoutClick()">Book nu</button>';

    wrap.innerHTML = html;
  };

  /* ── Postal code handler ───────────────────────────────────────── */
  ui.initPostalCode = function() {
    var input = U.$('#bk2-postal-input', S.container);
    if (!input) return;

    input.addEventListener('input', function() {
      var val = input.value.replace(/[^0-9]/g, '').substring(0, 4);
      input.value = val;
      S.postalCode = val;

      if (val.length < 4) {
        /* Don't check or clear anything until 4 digits — just let them type */
        return;
      }

      if (BR.API_BASE) {
        var postalWrap = input.closest('.bk2__postal-input-wrap');
        if (postalWrap) postalWrap.classList.add('bk2__postal--loading');
        fetch(BR.API_BASE + '/api/delivery-check/' + val)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (postalWrap) postalWrap.classList.remove('bk2__postal--loading');
            var rw = U.$('#bk2-postal-result', S.container);
            S.postalDeliverable = !!data.deliverable;
            S.postalCity = data.city || '';
            rw.innerHTML = data.deliverable
              ? '<div class="bk2__postal-ok">\u2713 Vi leverer til ' + U.esc(data.city || val) + '!</div>'
              : '<div class="bk2__postal-warn">Vi leverer desv\u00e6rre ikke til ' + U.esc(data.city || val) + '. V\u00e6lg afhentning ovenfor.</div>';
            /* Re-render fulfillment to show/hide delivery card — keep postal section visible */
            ui.renderFulfillment();
            var ps = U.$('#bk2-postal-section', S.container);
            if (ps) ps.style.display = 'block'; /* Always keep postal visible once opened */
            ui.syncStepStates();
          })
          .catch(function() {
            if (postalWrap) postalWrap.classList.remove('bk2__postal--loading');
            var zones = BR.config.delivery_zones || DEFAULTS.delivery_zones || [];
            S.postalDeliverable = zones.indexOf(val) !== -1 || zones.indexOf(parseInt(val)) !== -1;
            S.postalCity = '';
            var rw = U.$('#bk2-postal-result', S.container);
            rw.innerHTML = S.postalDeliverable
              ? '<div class="bk2__postal-ok">\u2713 Vi leverer til dit postnummer!</div>'
              : '<div class="bk2__postal-warn">Vi leverer desv\u00e6rre ikke til dette omr\u00e5de. V\u00e6lg afhentning ovenfor.</div>';
            ui.renderFulfillment();
            var ps2 = U.$('#bk2-postal-section', S.container);
            if (ps2) ps2.style.display = 'block';
            ui.syncStepStates();
          });
      } else {
        S.postalDeliverable = false;
        ui.renderFulfillment();
        ui.showStep('bk2-step-fulfill');
        ui.hideStep('bk2-step-period');
        ui.hideStep('bk2-step-contact');
        ui.hideStep('bk2-step-summary');
      }
    });
  };

  /* ── Contact handler ───────────────────────────────────────────── */
  ui.initContact = function() {
    U.$$('input[name="bk2-contact"]', S.container).forEach(function(r) {
      r.addEventListener('change', function() {
        S.contact = r.value;
        U.$$('.bk2__contact-opt', S.container).forEach(function(c) {
          c.classList.toggle('bk2__contact-opt--active', c.dataset.value === r.value);
        });
        ui.renderSummary();
        cart.setLineItemProps();
      });
    });
  };

  ui.initContactFields = function() {
    var et = U.$('#bk2-event-type', S.container);
    var cm = U.$('#bk2-comment', S.container);
    if (et) {
      et.addEventListener('change', function() { S.eventType = et.value; ui.renderSummary(); cart.setLineItemProps(); });
    }
    if (cm) {
      cm.addEventListener('input', function() { S.comment = cm.value; cart.setLineItemProps(); });
    }
    /* Update delivery address as user types — needed for isBookingComplete check */
    U.$$('#bk2-delivery-street, #bk2-delivery-city', S.container).forEach(function(el) {
      el.addEventListener('input', function() {
        var addr = U.$('#bk2-delivery-street', S.container);
        var city = U.$('#bk2-delivery-city', S.container);
        S.deliveryAddress = (addr && addr.value.trim()) ? addr.value.trim() + ', ' + (city && city.value.trim() || '') : '';
        ui.syncStepStates();
      });
    });
  };


  /* ═══════════════════════════════════════════════════════════════════
   * STICKY BAR — fixed bottom, visible after date selected
   * ═══════════════════════════════════════════════════════════════════ */

  ui.createStickyBar = function() {
    if (U.$('#bk2-sticky-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'bk2-sticky-bar';
    bar.className = 'bk2__sticky';
    /* Visibility is controlled via the --visible modifier class, NOT inline
     * display. The bar starts off-screen (transform:translateY(100%)); adding
     * the modifier slides it into view. Previously the JS toggled style.display
     * which left the transform intact and the bar permanently invisible. */
    bar.innerHTML =
      '<div class="bk2__sticky-inner">' +
        '<div class="bk2__sticky-info">' +
          '<span class="bk2__sticky-date" id="bk2-sticky-date"></span>' +
          '<span class="bk2__sticky-detail" id="bk2-sticky-detail"></span>' +
        '</div>' +
        '<div class="bk2__sticky-right">' +
          '<span class="bk2__sticky-price" id="bk2-sticky-price"></span>' +
          '<button type="button" id="bk2-sticky-btn" class="bk2__book-btn bk2__book-btn--sticky" disabled onclick="window.BaskasRental.cart.onCheckoutClick()">Book nu</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bar);
  };

  ui.updateStickyBar = function() {
    var bar = U.$('#bk2-sticky-bar');
    if (!bar) return;
    if (!S.eventDate) {
      bar.classList.remove('bk2__sticky--visible');
      document.body.classList.remove('bk2--has-sticky');
      return;
    }
    bar.classList.add('bk2__sticky--visible');
    /* Pushes page content up by the sticky bar's height so the summary's
     * own Book button isn't covered. */
    document.body.classList.add('bk2--has-sticky');

    var labels = getLabels();

    /* Date */
    var dateEl = U.$('#bk2-sticky-date');
    if (dateEl) {
      var ds = U.fmtShort(S.eventDate);
      if (S.eventEndDate) ds += ' – ' + U.fmtShort(S.eventEndDate);
      dateEl.textContent = ds;
    }

    /* Detail: model + qty + location */
    var detEl = U.$('#bk2-sticky-detail');
    if (detEl) {
      var parts = [];
      if (S.model) parts.push(S.quantity + 'x ' + (labels[S.model] || S.model));
      if (S.fulfillment === 'delivery') {
        parts.push('Levering');
      } else if (S.pickupLocation) {
        var locs = getLocations();
        for (var i = 0; i < locs.length; i++) {
          if (locs[i].id === S.pickupLocation) { parts.push(locs[i].name); break; }
        }
      }
      detEl.textContent = parts.join(' · ');
    }

    /* Price */
    var priceEl = U.$('#bk2-sticky-price');
    if (priceEl) {
      var t = cart.getTotal();
      priceEl.textContent = t > 0 ? U.fmtPriceShort(t) : '';
    }

    /* Button disabled until booking complete */
    var btn = U.$('#bk2-sticky-btn');
    if (btn) btn.disabled = !ui.isBookingComplete();
  };

  ui.hideStickyBar = function() {
    var b = U.$('#bk2-sticky-bar');
    if (b) b.classList.remove('bk2__sticky--visible');
    document.body.classList.remove('bk2--has-sticky');
  };


  /* ═══════════════════════════════════════════════════════════════════
   * FLOW ORCHESTRATION — date selected triggers downstream steps
   * ═══════════════════════════════════════════════════════════════════ */

  /*
   * STRICT SEQUENTIAL FLOW:
   * 1. Date picked     → show variant picker (model/antal)
   * 2. Model/qty set   → show addons
   * 3. (addons done)   → show postal (REQUIRED)
   * 4. Postal filled   → show fulfillment
   * 5. Fulfillment     → show period + contact
   * 6. Contact         → show summary
   *
   * Each step only appears after the previous is completed.
   */
  ui.onDateSelected = function() {
    if (!S.eventDate) return;
    ui.updateStickyBar();

    /* After date: show addons + fulfillment immediately */
    addons.render();
    ui.renderFulfillment();

    /* If fulfillment already chosen (auto-select), trigger downstream */
    if (S.pickupLocation || S.fulfillment === 'delivery') {
      ui._fetchAndShowWindows();
    }

    ui.syncStepStates();
    if (S.vpBlock) U.scrollToEl(S.vpBlock);
  };

  /* Fetch availability data then show period/contact/summary */
  ui._fetchAndShowWindows = function() {
    if (!S.eventDate) return;
    var myGen = _gen;
    var maxDur = getMaxDuration();
    var monthsNeeded = {};
    for (var offset = -maxDur; offset <= maxDur; offset++) {
      monthsNeeded[U.fmtMonth(U.addDays(S.eventDate, offset))] = true;
    }
    var months = Object.keys(monthsNeeded);
    var pending = 0;

    for (var i = 0; i < months.length; i++) {
      if (!cal.hasDataForMonth(months[i])) {
        pending++;
        cal.fetchAvailability(S.model, months[i], function() {
          if (_gen !== myGen) return;
          pending--;
          if (pending <= 0) { cal.render(); ui._showWindowsForDate(); }
        });
      }
    }
    if (pending === 0) ui._showWindowsForDate();
  };

  ui._showWindowsForDate = function() {
    if (!S.eventDate) return;
    var fb = U.$('#bk2-date-feedback', S.calWrap) || U.$('#bk2-date-feedback');
    var windows = cal.calculateWindows(S.eventDate, S.fulfillment);

    if (windows.length === 0) {
      var altMode = S.fulfillment === 'delivery' ? 'pickup' : 'delivery';
      windows = cal.calculateWindows(S.eventDate, altMode);
    }

    if (windows.length === 0) {
      S.selectedWindow = null;
      ui.hideStep('bk2-step-period');
      ui.hideStep('bk2-step-contact');
      ui.hideStep('bk2-step-summary');
      cart.removeLineItemProps();
      cart.updateBuyButtons();
      ui.updateStickyBar();

      var reason = cal.diagnoseNoWindows(S.eventDate, S.fulfillment);
      var msgs = {
        blocked:  ['Denne dato er ikke tilgængelig', 'Datoen er reserveret til et event. Kontakt os for mere info.', 'warn'],
        festival: ['Festivalperiode', 'Denne periode er reserveret til festival-udlejning. Tryk p\u00e5 datoen for at se hvilken festival.', 'warn'],
        soldout:  ['Udsolgt', 'Alle enheder er booket. Prøv en anden dato.', 'warn'],
        toosoon:  ['For tæt på', 'Kontakt os — vi kan ofte finde en løsning.', 'info'],
        nowindow: ['Ingen ledige perioder', 'Prøv en anden dato eller kontakt os.', 'info']
      };
      var m = msgs[reason] || msgs.nowindow;
      if (fb) fb.innerHTML = '<div class="bk2__feedback bk2__feedback--' + m[2] + '">' + BR.WARN + '<div><strong>' + m[0] + '</strong><p>' + m[1] + '</p></div></div>';
      return;
    }

    if (fb) fb.innerHTML = '';
    S.selectedWindow = windows[0];
    cal.render();
    ui.renderPeriodOptions(windows);
    ui.showStep('bk2-step-period');
    ui.showStep('bk2-step-contact');
    ui.renderSummary();
    ui.showStep('bk2-step-summary');
    cart.setLineItemProps();
    cart.updateBuyButtons();
    ui.updateDeliveryProgress();
    ui.updateStickyBar();
  };

  ui.onModelSelected = function() {
    _gen++; /* Invalidate all in-flight fetches */
    S.availability = {};
    S.locationStock = {};
    S.selectedWindow = null;
    S.selectedAddons = {};
    addons.clampQuantities();
    addons.render();
    ui.renderAntalUpsell();
    ui.renderValueStack();
    cal.render();
    if (S.eventDate) {
      ui.onDateSelected();
    } else {
      cal.fetchAvailability(S.model, U.fmtMonth(S.calendarMonth), function() { cal.render(); });
    }
    ui.updateStickyBar();
  };


  /* ═══════════════════════════════════════════════════════════════════
   * VARIANT CHANGE DETECTION — debounced + generation-guarded
   * ═══════════════════════════════════════════════════════════════════ */

  var _variantTimer = null;

  function onVariantChange() {
    /* Debounce: wait 200ms after the LAST click before processing.
       This collapses rapid clicks into a single state update. */
    if (_variantTimer) clearTimeout(_variantTimer);
    _variantTimer = setTimeout(_doVariantChange, 200);
  }

  function _doVariantChange() {
    _variantTimer = null;
    var m = BR.detectModel(), q = BR.detectQuantity();
    var mc = m !== S.model, qc = q !== S.quantity;
    if (!mc && !qc) return;

    _gen++; /* Invalidate ALL in-flight fetches — this is the key fix */

    S.model = m;
    S.quantity = q;
    ui.renderAntalUpsell();
    ui.renderValueStack();

    /*
     * NEVER clear S.eventDate — the user's party date doesn't change
     * when they switch speakers or quantity. Just refetch availability.
     */
    S.availability = {};
    S.locationStock = {};
    S.selectedWindow = null;
    if (mc) { S.selectedAddons = {}; addons.fetchAddons(); }
    if (qc) addons.clampQuantities();

    /* Refresh calendar dots for new model/qty — recalculate windows AFTER data arrives */
    cal.render();
    ui.syncStepStates(); /* Show locked state while loading */
    cal.fetchAvailability(m, U.fmtMonth(S.calendarMonth), function() {
      cal.render();
      if (S.eventDate) {
        ui.onDateSelected();
      }
      ui.updateStickyBar();
    });
  }

  ui.watchVariantChanges = function() {
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-option-value],.product-form__swatch__item,.product-form__swatch')) {
        onVariantChange(); /* Debounce handles the rest */
      }
    });
    document.addEventListener('change', function(e) {
      if (e.target.name === 'Model' || e.target.name === 'Antal') {
        onVariantChange();
      }
    });
  };


  /* ═══════════════════════════════════════════════════════════════════
   * MODULE 7: INIT
   * ═══════════════════════════════════════════════════════════════════ */

  ui._initialized = false;

  ui.init = function() {
    if (ui._initialized) return;
    ui._initialized = true;

    try {
      /* Skip for festival products */
      if (ui.isFestivalProduct()) return;

      /* Hide old izyrent calendar */
      var iz = U.$('.product-single__box__block--\\@app');
      if (iz) iz.style.display = 'none';
      var izC = document.getElementById('izyrent_product_calendar');
      if (izC) { var cl = izC.closest('.shopify-block'); if (cl) cl.style.display = 'none'; }

      /*
       * Layout:
       *   [Title + Price]
       *   [Calendar]          ← bk2-cal-wrap, inserted BEFORE variant picker
       *   [Variant picker]    ← Shopify native, untouched
       *   [Rest of flow]      ← baskas-booking-flow (from Liquid template or created)
       */
      var vpBlock = U.$('.product-single__box__block--variant_picker');

      /* Calendar wrapper — create and insert BEFORE variant picker */
      var calWrap = document.getElementById('bk2-cal-wrap');
      if (!calWrap) {
        calWrap = document.createElement('div');
        calWrap.id = 'bk2-cal-wrap';
        if (vpBlock) {
          vpBlock.parentNode.insertBefore(calWrap, vpBlock);
        } else {
          var bb1 = U.$('.product-single__box__block--buy_buttons,[data-buy-buttons]');
          if (bb1) bb1.parentNode.insertBefore(calWrap, bb1);
        }
      }

      /* Rest of flow — use existing Liquid container or create after VP */
      var container = document.getElementById('baskas-booking-flow');
      if (!container) {
        container = document.createElement('div');
        container.id = 'baskas-booking-flow';
        container.style.margin = '16px 0';
        var bb2 = U.$('.product-single__box__block--buy_buttons,[data-buy-buttons]');
        if (bb2) bb2.parentNode.insertBefore(container, bb2);
      }

      S.calWrap = calWrap;
      S.container = container;
      S.vpBlock = vpBlock;

      /* Load config then render */
      BR.loadConfig().then(ui._doRender).catch(function(err) {
        console.error('[BaskasRental] Config failed:', err);
        BR.config = BR.config || {};
        ui._doRender();
      });
    } catch (err) {
      console.error('[BaskasRental] Init error:', err);
    }
  };

  ui._doRender = function() {
    try {
      /* Detect model & quantity */
      S.model = BR.detectModel();
      S.quantity = BR.detectQuantity();
      S.calendarMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

      /* Parse variants for price lookup */
      BR.parseVariants();

      /* Pre-fetch addons */
      addons.fetchAddons();

      /* Render calendar (above VP) and flow (below VP) */
      ui.renderCalendar();
      ui.renderFlow(S.container);

      /* Inject upsell + value stack into variant picker */
      ui.injectVariantSteps();
      ui.renderAntalUpsell();
      ui.renderValueStack();
      cart.updateBuyButtons();

      /* Create sticky bar */
      ui.createStickyBar();

      /* Watch variant changes */
      ui.watchVariantChanges();

      /* Render calendar — all future dates clickable */
      cal.render();
      if (BR.API_BASE) {
        /* Auto-select first available Saturday — searches current + next month */
        var _tryAutoSelect = function(days) {
          if (S.eventDate) return; /* User already picked a date */
          if (!days || !days.length) return;
          var today = new Date(); today.setHours(0,0,0,0);
          for (var i = 0; i < days.length; i++) {
            var d = days[i];
            if (d.blocked || d.available <= 0) continue;
            var dt = U.dateFromStr(String(d.date));
            if (dt <= today) continue;
            if (dt.getDay() === 6) { /* Saturday */
              cal.onDateClicked(dt);
              return;
            }
          }
        };

        cal.fetchAvailability(S.model, U.fmtMonth(S.calendarMonth), function(days) {
          cal.render();
          _tryAutoSelect(days);
          /* If no Saturday found this month, try next month */
          if (!S.eventDate) {
            var nextMonth = new Date(S.calendarMonth.getFullYear(), S.calendarMonth.getMonth() + 1, 1);
            cal.fetchAvailability(S.model, U.fmtMonth(nextMonth), function(days2) {
              _tryAutoSelect(days2);
              /* If still no Saturday, auto-select first available day */
              if (!S.eventDate && days2 && days2.length) {
                for (var j = 0; j < days2.length; j++) {
                  var d2 = days2[j];
                  if (!d2.blocked && d2.available > 0) {
                    var dt2 = U.dateFromStr(String(d2.date));
                    if (dt2 > new Date()) {
                      /* Navigate calendar to that month first */
                      S.calendarMonth = nextMonth;
                      cal.render();
                      cal.onDateClicked(dt2);
                      break;
                    }
                  }
                }
              }
            });
          }
        });
      }

      // Wire up locked-step click → scroll to prerequisite
      U.$$('.bk2__step--locked .bk2__step-head', S.container).forEach(function(head) {
        head.addEventListener('click', function() {
          var step = head.closest('.bk2__step');
          var hint = step && step.querySelector('.bk2__step-hint');
          if (hint) {
            hint.style.display = 'block';
            // Find the first active step and scroll to it
            var active = U.$('.bk2__step--active', S.container);
            if (active) {
              active.classList.add('bk2__step--pulse');
              U.scrollToEl(active);
              setTimeout(function() { active.classList.remove('bk2__step--pulse'); }, 1500);
            }
          }
        });
      });
    } catch (err) {
      console.error('[BaskasRental] Render error:', err);
    }
  };


  /* ═══════════════════════════════════════════════════════════════════
   * AUTO-INIT — robust three-layer initialization
   * ═══════════════════════════════════════════════════════════════════ */

  function tryInit(attempt) {
    if (ui._initialized) return;
    var container = document.getElementById('baskas-booking-flow') || document.getElementById('baskas-calendar');
    var hasForm = document.querySelector('form[action*="/cart/add"]');

    if (container && hasForm) {
      ui.init();
      return;
    }

    if (attempt < 15) {
      setTimeout(function() { tryInit(attempt + 1); }, 200);
    } else {
      console.warn('[BaskasRental] Max attempts, forcing init');
      ui.init();
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryInit(0);
  } else {
    document.addEventListener('DOMContentLoaded', function() { tryInit(0); });
  }
  window.addEventListener('load', function() {
    if (!ui._initialized) tryInit(0);
  });

})(window.BaskasRental);
